import * as React from "react";
import {themeTokens} from "@octopusdeploy/design-system-tokens";
import FormFieldProps from "../FormFieldProps";
import styles = require("./style.less");

type Props = FormFieldProps<number> & {
    disabled?: boolean;
    max?: number;
    min?: number;
    label?: string;
    step?: number;
}

const Slider = (props: Props) => {
    const {onChange, label, value, disabled, max = 1, min = 0, step = 0.01} = props;

    return <div className={styles.container}>
        {label && <label className={styles.label}>{label}</label>}
        <input
            type="range"
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            disabled={disabled}
            min={min}
            max={max}
            step={step}
            style={{
                flexGrow: 1,
                accentColor: themeTokens.color.text.link.default,
            }}
        />
        <span className={styles.value}>{value}%</span>
    </div>;
};

export default Slider;
